import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { AgingTimeUnit, RumType } from 'src/app/products/interfaces/models';
import { SubformBaseComponent } from 'src/app/shared/components/subform-base/subform-base.component';

import { RumProperties } from '@app/api/marketplace/models';
import { NotEmptyFieldsStateMatcher } from '@shared/helpers/not-empty-fields-error-state-matcher';
import { notEmptyFieldsValidator } from '@shared/validators/not-empty-fields.validator';

@Component({
  selector: 'app-rum-properties-subform',
  templateUrl: './rum-properties-subform.component.html',
  styleUrls: ['./rum-properties-subform.component.scss'],
})
export class RumPropertiesSubformComponent extends SubformBaseComponent {
  DICT_PATH = 'PRODUCTS.RUM_PROPERTIES';

  rumTypes = RumType;
  agingTimeUnits = AgingTimeUnit;

  notEmptyFieldsStateMatcher = new NotEmptyFieldsStateMatcher();

  Validators = Validators;

  selectBoolean = { True: true, False: false };

  static originalVolatileSubstance = false;

  originalValue79Eur = null;
  originalValue2Eur = null;

  static buildForm(fb: FormBuilder, data?: RumProperties) {
    this.originalVolatileSubstance =
      data?.volatileSubstanceAtLeast225gphl ?? false;
    return fb.group(
      {
        type: [data?.type, Validators.required],
        agingTime: [data?.agingTime],
        agingTimeUnit: [
          data?.agingTimeUnit,
          data?.agingTime ? [Validators.required] : [],
        ],
        volatileSubstanceAtLeast225gphl:
          data?.volatileSubstanceAtLeast225gphl ?? false,
        calculatedPureAlcoholExceeding7_9EURperLiter:
          data?.calculatedPureAlcoholExceeding7_9EURperLiter,
        calculatedPureAlcoholExceeding2EURperLiter:
          data?.calculatedPureAlcoholExceeding2EURperLiter,
      },
      {
        validators: notEmptyFieldsValidator([
          'calculatedPureAlcoholExceeding7_9EURperLiter',
          'calculatedPureAlcoholExceeding2EURperLiter',
        ]),
      }
    );
  }

  volatileChanged(event: boolean): void {
    if (event === RumPropertiesSubformComponent.originalVolatileSubstance) {
      return;
    }
    RumPropertiesSubformComponent.originalVolatileSubstance = event;
    if (event) {
      this.nullAndDisableControl(
        'calculatedPureAlcoholExceeding7_9EURperLiter'
      );
      this.nullAndDisableControl('calculatedPureAlcoholExceeding2EURperLiter');
    } else {
      this.getCtrl('calculatedPureAlcoholExceeding7_9EURperLiter')?.enable();
      this.getCtrl('calculatedPureAlcoholExceeding2EURperLiter')?.enable();
    }
  }

  pureAlcoholChanged79Eur() {
    this.originalValue79Eur = this.getCtrl(
      'calculatedPureAlcoholExceeding7_9EURperLiter'
    )?.value;
    if (this.originalValue79Eur !== null) {
      this.nullAndDisableControl('calculatedPureAlcoholExceeding2EURperLiter');
    } else {
      this.getCtrl('calculatedPureAlcoholExceeding2EURperLiter')?.enable();
    }
  }

  pureAlcoholChanged2Eur() {
    this.originalValue2Eur = this.getCtrl(
      'calculatedPureAlcoholExceeding2EURperLiter'
    )?.value;
    if (this.originalValue2Eur !== null) {
      this.nullAndDisableControl(
        'calculatedPureAlcoholExceeding7_9EURperLiter'
      );
    } else {
      this.getCtrl('calculatedPureAlcoholExceeding7_9EURperLiter')?.enable();
    }
  }

  nullAndDisableControl(controlName: string) {
    this.getCtrl(controlName)?.setValue(null, {
      emitModelToViewChange: false,
    });
    this.getCtrl(controlName)?.disable();
  }
}
